import { useEffect } from 'react';
import { FM_ACTIONS } from '../../utils/UtilFunctions';
import { handleTrack } from '../../utils/tracker';
import { IMATRIX_PROPS } from '../cms/layout/types';

export const useOnMountFunnelMetrics = ({
  parentCategory,
  category = '',
  action = FM_ACTIONS.pageview,
}: IMATRIX_PROPS): void => {
  useEffect(() => {
    if (window === undefined) return;
    handleTrack({
      label: window.location.pathname,
      action: action,
      parentCategory: parentCategory,
      categoryName: category,
    });
  }, []);
};
